module.exports = __webpack_public_path__ + "assets/images/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./assets/images/favicon.ico
// module id = 1717
// module chunks = 0